import { undoDepth, redoDepth } from '@codemirror/commands';
import { EditorView, ViewPlugin, ViewUpdate } from '@codemirror/view';

import { CodePasteTracker, ExternalPasteChecker } from './code-pastes';

export function trackCodeSession(pasteTracker: CodePasteTracker) {
    const pasteChecker = new ExternalPasteChecker();
    return ViewPlugin.fromClass(
        class {
            constructor(_view: EditorView) {}

            update(update: ViewUpdate): void {
                for (const transaction of update.transactions) {
                    if (transaction.isUserEvent('input.paste') || transaction.isUserEvent('input.drop')) {
                        // Explicit paste and drag'n'drop events
                        // eslint-disable-next-line max-params
                        transaction.changes.iterChanges((_fromA, _toA, _fromB, _toB, inserted) => {
                            if (inserted.length > 0) {
                                const paste = pasteChecker.check(inserted, transaction.startState.doc);
                                pasteTracker.attachPaste(paste, {
                                    undo: undoDepth(transaction.startState),
                                    redo: redoDepth(transaction.startState),
                                });
                            }
                        });
                    } else if (transaction.isUserEvent('input')) {
                        // Other input events like accepting a suggestion from mobile keyboard
                        // eslint-disable-next-line max-params
                        transaction.changes.iterChanges((_fromA, _toA, _fromB, _toB, inserted) => {
                            if (pasteChecker.isAnyInputLooksLikePaste(inserted)) {
                                const paste = pasteChecker.check(inserted, transaction.startState.doc);
                                pasteTracker.attachPaste(paste, {
                                    undo: undoDepth(transaction.startState),
                                    redo: redoDepth(transaction.startState),
                                });
                            }
                        });
                    } else if (transaction.isUserEvent('delete.cut')) {
                        const invertedSet = transaction.changes.invert(transaction.startState.doc);
                        // eslint-disable-next-line max-params
                        invertedSet.iterChanges((_fromA, _toA, _fromB, _toB, inserted) => {
                            if (inserted.length > 0) {
                                pasteChecker.setLatestCopiedText(inserted.toString());
                            }
                        });
                    }

                    if (transaction.docChanged) {
                        pasteTracker.onChange({
                            undo: undoDepth(transaction.state),
                            redo: redoDepth(transaction.state),
                        });
                    }
                }
            }

            destroy() {}
        },
        {
            eventObservers: {
                copy: (_event, view) => {
                    const selection = view.state.selection.main;
                    const selectedText = view.state.sliceDoc(selection.from, selection.to);
                    pasteChecker.setLatestCopiedText(selectedText);
                },
            },
        }
    );
}
